import { pasteAttachesFiles } from "./chat-attachment-paste";

interface ParagraphTextNode {
  type: "text";
  text: string;
}

interface HardBreakNode {
  type: "hardBreak";
}

export interface ParagraphNode {
  type: "paragraph";
  content: Array<ParagraphTextNode | HardBreakNode>;
}

const PARAGRAPH_BREAK = "\n\n";

function lineContent(line: string): ParagraphTextNode[] {
  return line ? [{ type: "text", text: line }] : [];
}

export function editorTextToParagraphNodes(value: string): ParagraphNode[] {
  return value.replace(/\r\n?/g, "\n").split(PARAGRAPH_BREAK).map(paragraph => ({
    type: "paragraph",
    content: paragraph.split("\n").flatMap((line, index) =>
      index === 0 ? lineContent(line) : [{ type: "hardBreak" as const }, ...lineContent(line)]
    )
  }));
}

export interface ParagraphInsertChain {
  focus(): ParagraphInsertChain;
  selectAll(): ParagraphInsertChain;
  insertContent(content: ParagraphNode[]): ParagraphInsertChain;
  run(): boolean;
}

export interface ParagraphInsertingEditor {
  isEmpty: boolean;
  chain(): ParagraphInsertChain;
}

export function insertPlainTextPaste(editor: ParagraphInsertingEditor, text: string): void {
  const pasted = editorTextToParagraphNodes(text);
  if (editor.isEmpty) {
    editor.chain().focus().selectAll().insertContent(pasted).run();
    return;
  }
  editor.chain().focus().insertContent(pasted).run();
}

export type PlainTextPasteHandler = (view: unknown, event: ClipboardEvent) => boolean;

export function plainTextPasteHandler(currentEditor: () => ParagraphInsertingEditor | null): PlainTextPasteHandler {
  return (_view, event) => {
    const editor = currentEditor();
    const pasteData = event.clipboardData;
    const text = pasteData?.getData("text/plain");
    if (!editor || !pasteData || !text || pasteAttachesFiles(pasteData)) return false;
    event.preventDefault();
    insertPlainTextPaste(editor, text);
    return true;
  };
}
